import { render } from "./TheDiemTienIch.vue?vue&type=template&id=09913212"
import script from "./TheDiemTienIch.vue?vue&type=script&lang=js"
export * from "./TheDiemTienIch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__